import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { WindowService } from "../../modules/shared/window";

const REDIRECT_KEYNAME = "_r";

@Injectable({
    providedIn: "root",
})
export class RedirectorService {
    private redirectUrl: string | null = null;
    errorMsg?: string;

    constructor(
        private windowService: WindowService,
        private router: Router,
    ) {
        this.init();
    }

    private init(): void {
        this.redirectUrl = this.windowService.getKeyValue(REDIRECT_KEYNAME) as string | null;
    }

    setRedirect(redirectUrl: string): void {
        this.redirectUrl = redirectUrl;
        this.windowService.setKeyValue(REDIRECT_KEYNAME, redirectUrl);
    }

    clearRedirect(): void {
        this.redirectUrl = null;
        this.windowService.removeKeyValue(REDIRECT_KEYNAME);
    }

    resolveRedirect(currentUrl: string): true | UrlTree {
        if (!this.redirectUrl) {
            return true;
        }

        const redirect = this.router.parseUrl(this.redirectUrl);
        this.clearRedirect();
        return this.router.serializeUrl(redirect) === currentUrl ? true : redirect;
    }
}
